import Immutable from 'immutable';
import {
  CLEAR_DRIVERS_MOVEMENT,
  CLEAR_DRIVER_MOVEMENT,
  FLAG_DRIVER_MOVEMENT_ACTIVITY,
  FLAG_GETTING_DRIVERS_MOVEMENT,
  GET_DRIVERS_MOVEMENT,
  GET_DRIVER_MOVEMENT,
} from '../../../actions/types/traffic/DriverMovement';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_DRIVERS_MOVEMENT:
      return state.setIn(['all', 'loading'], payload);
    case GET_DRIVERS_MOVEMENT:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_DRIVERS_MOVEMENT:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_DRIVER_MOVEMENT_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_DRIVER_MOVEMENT:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_DRIVER_MOVEMENT:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
